import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import axios from "axios";
import { Container, Row, Col, Button, Form, Input } from "reactstrap";
import { config } from "../../constants/domainConfig";
import * as vars from "../../constants/constants";
import { messages } from "../../constants/messages";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { showMessage } from "../../actions/FlashMessageActions";
import {
  getDetails,
  setDetails,
  setProfilePic,
  getInterests,
} from "../../actions/AccountActions";
import { setHeaderTitle } from "../../actions/HeaderActions";
import { console_log, parseQueryString } from "../../utils/helper";
import { FormattedMessage } from "react-intl";

import { timezone } from "../../constants/timezones";
import { sendData } from "../../analytics/sendData";
import { isWithdrawEnabled } from "../../utils/withdraw-contract";

// const msg = messages[config.lang];

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      emailAddress: "",
      location: "",
      interests: [],
      accountType: "standard",
      timeZone: "+0:00",
      photo: "",
      photoFile: null,
    };
    this.editForm = this.editForm.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.onUnsub = this.onUnsub.bind(this);
  }

  componentWillMount() {
    if (
      config.subDomain == "be" ||
      config.subDomain == "it" ||
      config.subDomain == "id" ||
      config.subDomain == "nl" ||
      config.subDomain === "se" ||
      config.subDomain === "iq" ||
      config.subDomain === "no"
    )
      this.props.account.interests = this.translateInterests(
        this.props.account.interests,
      );
    this.setState({
      name: this.props.account.user.name,
      emailAddress: this.props.account.user.email,
      location: this.props.account.user.address,
      interests: this.props.account.user.userInterests
        ? this.props.account.user.userInterests.map((i) => {
            return i.interestId;
          })
        : [],
      accountType: this.props.account.user.accountType,
      timeZone: this.props.account.user.timeZone,
    });
  }

  componentDidMount() {
    document.body.classList.add("account-page");
    let account;
    if (config.subDomain == "es") {
      account = "Mi cuenta";
    } else if (config.subDomain == "be" || config.subDomain == "nl") {
      account = "Mijn account";
    } else if (config.subDomain == "id") {
      account = "Akun Saya";
    } else if (config.subDomain == "it") {
      account = "Il mio account";
    } else if (config.subDomain == "se") {
      account = "Mitt konto";
    } else if (config.lang == "no") {
      account = "Min konto";
    } else if (config.subDomain == "sn") {
      account = "Mon compte";
    } else if (config.subDomain == "ee") {
      account = "Minu konto";
    } else if (config.subDomain == "tr") {
      account = "Hesabım";
    } else if (config.subDomain == "lv") {
      account = "Mans konts";
    } else if (config.subDomain == "lt") {
      account = "Mano paskyra";
    } else if (config.subDomain == "rs") {
      account = "Мој профил";
    } else if (config.subDomain == "gr") {
      account = "Ο λογαριασμός μου";
    } else if (config.lang == "fr") {
      account = "Mon compte";
    } else if (config.subDomain == "ch") {
      account = "Mein Konto";
    } else if (config.subDomain == "th") {
      account = "บัญชีของฉัน";
    } else if (config.subDomain == "cz") {
      account = "Můj účet";
    } else if (config.lang === "es") {
      account = "Mi cuenta";
    } else if (config.lang === "pt") {
      account = "Minha Conta";
    } else {
      account = "My Account";
    }
    if (config.lang == "ar") {
      account = "الحساب";
    }
    this.props.setHeaderTitle(account);
    window.scrollTo(0, 0);
  }
  translateInterests(interests) {
    let interestsEn = [
      "Sports",
      "Action",
      "Adventure",
      "Fitness",
      "Entertainment",
    ];
    let interestsBe = [
      "Sporten",
      "Actie",
      "Avontuur",
      "Fitness",
      "Entertainment",
    ];
    let interestsId = [
      "Olahraga",
      "Laga",
      "Petualangan",
      "Kebugaran",
      "Entertainment",
    ];
    let interestsIt = [
      "Sport",
      "Azione",
      "Avventura",
      "Fitness",
      "Intrattenimento",
    ];
    let interestsSe = [
      "Sporter",
      "Action",
      "Äventyr",
      "Fitness",
      "Underhållning",
    ];
    let interestsAr = ["رياضات", "اكشن", "مغامرة", "اللياقه البدنيه", "ترفيه"];
    let interestsNo = [
      "Sports",
      "Action",
      "Adventure",
      "Fitness",
      "Entertainment",
    ];
    let translatedInterests = interests.map((interest) => {
      if (interestsEn.includes(interest.name)) {
        if (config.lang == "ar") {
          return {
            ...interest,
            name: interestsAr[interestsEn.indexOf(interest.name)],
          };
        }
        if (config.subDomain === "be" || config.subDomain === "nl") {
          return {
            ...interest,
            name: interestsBe[interestsEn.indexOf(interest.name)],
          };
        } else if (config.subDomain === "id") {
          return {
            ...interest,
            name: interestsId[interestsEn.indexOf(interest.name)],
          };
        } else if (config.subDomain === "it") {
          return {
            ...interest,
            name: interestsIt[interestsEn.indexOf(interest.name)],
          };
        } else if (config.subDomain === "se") {
          return {
            ...interest,
            name: interestsSe[interestsEn.indexOf(interest.name)],
          };
        } else if (config.subDomain === "no") {
          return {
            ...interest,
            name: interestsNo[interestsEn.indexOf(interest.name)],
          };
        }
      } else {
        return interest;
      }
    });
    return translatedInterests;
  }

  componentWillUnmount() {
    document.body.classList.remove("account-page");
  }

  editForm(e) {
    if (this.validateForm()) {
      this.submitForm();
    }
  }

  validateForm() {
    let regExp =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (
      this.state.emailAddress != "" &&
      !regExp.test(this.state.emailAddress)
    ) {
      this.props.showMessage({
        message: messages[config.lang].emailNotValid,
        type: false,
      });
      return false;
    }
    return true;
  }

  submitForm() {
    let user = this.props.account.user;
    user.name = this.state.name;
    user.email = this.state.emailAddress;
    user.address = this.state.location;
    user.interests = this.state.interests;
    user.accountType = this.state.accountType;
    user.timeZone = this.state.timeZone;

    axios
      .put(vars.BASE_API_URL + "/editProfile", user)
      .then((response) => {
        this.props.showMessage({
          message: messages[config.lang].profileSaved,
          type: true,
        });
        console_log(response);
      })
      .catch((error) => {
        console_log(error);
      });

    this.props.setDetails(user);
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onCategoryChange(e) {
    let interest = this.state.interests,
      indexOf = interest.indexOf(parseInt(e.target.name));
    if (indexOf == -1) {
      interest.push(parseInt(e.target.name));
    } else {
      interest = interest.filter((c) => c !== parseInt(e.target.name));
    }

    this.setState({
      interests: interest,
    });
  }

  onUnsub(e) {
    sendData("", "", "", "Unsubscribed", { uid: this.props.access.uid });
    window.open(e.target.id);
  }

  onFileChange(e) {
    let reader = new FileReader(),
      file = e.target.files[0];
    let base64Data;
    reader.readAsDataURL(file);
    let currentThis = this;
    reader.onloadend = function () {
      base64Data = reader.result;
      currentThis.props.show();
      axios
        .post(vars.BASE_API_URL + "/upload", { profilePic: base64Data })
        .then((response) => {
          currentThis.props.showMessage({
            message: messages[config.lang].profilePic,
            type: true,
          });
          currentThis.props.setProfilePic(response.data.data.profilePic);
          currentThis.props.hide();
        })
        .catch((error) => {
          currentThis.props.hide();
          console_log(error);
        });
      currentThis.setState({
        photo: [reader.result],
        photoFile: file,
      });
    };
  }

  render() {
    const authorized = sessionStorage.getItem("authorized")
      ? JSON.parse(sessionStorage.getItem("authorized"))
      : null;
    let intrestsEnglish = [
      "Sports",
      "Action",
      "Adventure",
      "Fitness",
      "Entertainment",
    ];
    let intrests;
    if (config.language == "spanish") {
      intrests = [
        { interestId: 1, name: "Deportes" },
        { interestId: 2, name: "Acción" },
        { interestId: 3, name: "Aventura" },
        { interestId: 4, name: "Fitness" },
        { interestId: 5, name: "Entretenimiento" },
      ];
    } else {
      intrests = this.props.account.interests;
    }
    let ppLink = {
      uk: "http://n.mobiotv.com/uk/tnc-mobiotv?offer=1&device=pc&_next=index.html&_next=privacy_policy.html",
      vn: "http://n.mobiotv.com/uk/tnc-mobiotv?offer=1&device=pc&_next=index.html&_next=privacy_policy.html",
      "pt.videoflux":
        "https://c1.mouisys.com/content/pt/privacy-videoflux-pt/?country=pt&service=videoflux",
    };
    let tncLink = {
      uk: "http://n.mobiotv.com/uk/tnc-mobiotv?offer=1&device=pc&_next=privacy_policy.html&_next=index.html",
      vn: "http://n.mobiotv.com/uk/tnc-mobiotv?offer=1&device=pc&_next=privacy_policy.html&_next=index.html",
      be: "http://n.mobiotv.com/be/tnc-mobiotv?offer=1&_next=general_conditions.html",
      nl: "http://n.mobiotv.com/nl/tnc-mobiotv?offer=1&_next=general_conditions.html",
      gh: "http://n.mobiotv.com/gh/tnc-mobiotv?device=pc&offer=1",
      no: "http://n.mobiotv.com/no/tnc-mobiotv?offer=1",
      ee: "http://n.mobiotv.com/ee/tnc-mobiotv?offer=1&device=pc&brand_name=mobiotv&_next=general_conditions.html",
      "es.trendme":
        "https://n.trendme.co/es/tnc-trendme?offer=1&_next=general_conditions.html",
      "pt.videoflux":
        "https://c1.mouisys.com/content/pt/terms-videoflux-pt/?country=pt&service=videoflux",
    };
    let unsubLink = {
      uk: `http://n.mobiotv.com/unsubscribe/uk/?token=${authorized.uid}`,
      vn: `http://n.mobiotv.com/unsubscribe/uk/?token=${authorized.uid}`,
      be: `http://n.mobiotv.com/unsubscribe/be/?domain=be.mobiotv.com&token=${authorized.uid}`,
      it: `http://n.mobiotv.com/unsubscribe/it/?token=${authorized.uid}`,
      se: `http://n.mobiotv.com/unsubscribe/uk/?token=${authorized.uid}`,
      gh: `http://n.mobiotv.com/unsubscribe/gh/?token=${authorized.uid}`,
      no: `http://n.mobiotv.com/unsubscribe/no/?uid=${authorized.uid}`,
      sn: `http://n.mobiotv.com/unsubscribe/sn/?token=${authorized.uid}`,
      tr: `http://n.mobiotv.com/unsubscribe/tr/?country=tr&domain=tr.mobiotv.com&token=${authorized.uid}`,
      ee: `http://n.mobiotv.com/unsubscribe/ee/?country=ee&domain=ee.mobiotv.com&token=${authorized.uid}`,
      ch: `http://n.mobiotv.com/unsubscribe/ch/?lang=${config.lang}&token=${authorized.uid}`,
      my: `https://m.mobiotv.com/unsubscribe/my?lang=en?domain=my.mobiotv.com&platform=mcb&skip_identify=true&token=${authorized.uid}`,
      cz: `https://n.mobiotv.com/unsubscribe/cz?lang=cz&token=${authorized.uid}`,
      "es.trendme": `https://n.trendme.co/unsubscribe/es?lang=es&token=${authorized.uid}`,
    };
    const { msisdn } = this.props.account.user;
    const product = window.location.hostname;
    const { country, lang, subDomain } = config;
    return (
      <section
        className="account"
        style={config.lang === "ar" ? { direction: "ltr" } : {}}
      >
        <button
          className="edit-button"
          onClick={this.editForm}
          style={config.lang === "ar" ? { left: "20px", right: "unset" } : {}}
        >
          <FormattedMessage id="save" defaultMessage="Save" />
        </button>
        <Container fluid>
          <Form
            className="account-form account-form--editable"
            action=""
            method="post"
          >
            <Row>
              <Col sm="8" xs="7">
                <div className="account__fields">
                  <h3
                    className={
                      config.useMobiofitTheme
                        ? "account__title account__title-mobiofit"
                        : "account__title"
                    }
                  >
                    <FormattedMessage
                      id="accountDetails"
                      defaultMessage="Account Details"
                    />
                  </h3>
                  <div className="account__input">
                    <label className="account__input__label" htmlFor="name">
                      <FormattedMessage id="name" defaultMessage="Name" />
                    </label>
                    <input
                      className="account__input__field"
                      type="text"
                      name="name"
                      id="name"
                      value={this.state.name}
                      onChange={this.onChange}
                    />
                    {/* <span className="account__input__border"></span> */}
                  </div>
                  <div className="account__input">
                    <label
                      className="account__input__label"
                      htmlFor="emailAddress"
                    >
                      <FormattedMessage
                        id="emailAddress"
                        defaultMessage="Email Address"
                      />
                    </label>
                    <input
                      className="account__input__field"
                      type="text"
                      name="emailAddress"
                      id="emailAddress"
                      value={this.state.emailAddress}
                      onChange={this.onChange}
                    />
                    {/* <span className="account__input__border"></span> */}
                  </div>
                </div>
                {intrests ? (
                  <div className="account__fields">
                    <h3
                      className={
                        config.useMobiofitTheme
                          ? "account__title account__title-mobiofit"
                          : "account__title"
                      }
                    >
                      <FormattedMessage
                        id="interests"
                        defaultMessage="Interests"
                      />
                    </h3>
                    <span className="hint-text">
                      <FormattedMessage
                        id="chooseGenre"
                        defaultMessage="Choose Your Genre"
                      />
                    </span>
                    <div className="account__checkbox-wrap">
                      {intrests.map((interest, k) => {
                        return (
                          <div key={k} className="account__input">
                            <input
                              type="checkbox"
                              className="common-checkbox"
                              name={interest.interestId}
                              id={interest.interestId}
                              checked={
                                this.state.interests.indexOf(
                                  interest.interestId,
                                ) !== -1
                                  ? true
                                  : false
                              }
                              onChange={this.onCategoryChange}
                            />
                            <label
                              className="account__default__label"
                              htmlFor={interest.interestId}
                            >
                              {
                                <FormattedMessage
                                  id={intrestsEnglish[k]}
                                  defaultMessage={intrestsEnglish[k]}
                                />
                              }
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </Col>
              <Col sm="4" xs="5">
                <div className="account__image">
                  <div className="account__input">
                    <label
                      className="account__input__label account__input__label--image"
                      htmlFor="photo"
                    >
                      <img
                        className="avatar-image"
                        src={
                          this.state.photo
                            ? this.state.photo
                            : this.props.account.user.profilePic
                              ? this.props.account.user.profilePic
                              : "img/avatar-with-camera.png"
                        }
                        alt="Edit Photo"
                      />
                      <span className="avatar-text">
                        <FormattedMessage
                          id="editPhoto"
                          defaultMessage="Edit Photo"
                        />
                      </span>
                    </label>
                    <input
                      type="file"
                      className="account__input__field"
                      name="photo"
                      id="photo"
                      accept="image/gif, image/jpeg, image/png"
                      onChange={this.onFileChange}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
          {config.subDomain == "za.fun-box" ? (
            <div className="unsubscribe_field">
              <h3 className={"account__title"}>
                <FormattedMessage
                  id="unsubscribe"
                  defaultMessage="Unsubscribe"
                />
              </h3>
              <ul>
                <li>
                  <h6>MTN</h6>
                  <p>
                    To unsubscribe, email{" "}
                    <strong>info@smartcalltech.co.za</strong> or phone
                    0115074779.
                  </p>
                </li>
                <li>
                  <h6>Vodacom</h6>
                  <p>
                    To unsubscribe, dial <strong>*135*997#</strong>
                  </p>
                </li>
              </ul>
            </div>
          ) : (
            ""
          )}
          {isWithdrawEnabled(
            config.subDomain,
            config.newDomain || config.mainDomain,
          ) ? (
            <div
              className="account__links__btn-wrap"
              style={{ marginTop: "20px" }}
            >
              <a
                className="account__links__btn"
                href={`https://checksubscription.com/withdraw?c=${subDomain}&product=${product}&country=${country}&language=${lang}&rockmanId=${authorized ? authorized.rockmanId || "" : ""}&msisdn=${msisdn || ""}`}
                target="_blank"
                rel="noopener noreferrer"
                style={
                  config.subDomain === "pt" && config.newDomain === "videoflux"
                    ? { color: "#d51a92" }
                    : { color: "#57A67C" }
                }
              >
                <FormattedMessage
                  id="withdrawFromContract"
                  defaultMessage="Withdraw from Contract"
                />
              </a>
            </div>
          ) : (
            ""
          )}

          {config.subDomain == "uk" && window.innerWidth <= 575 ? (
            <div className="account__links">
              <div className="account__links__btn-wrap">
                <a
                  className="account__links__btn"
                  href={`/#/home?uid=${this.props.access.uid}`}
                  onClick={(e) =>
                    (window.location = `http://n.lumibrain.com/api/samAuth/?token=${this.props.access.uid}`)
                  }
                >
                  <FormattedMessage id="iq" defaultMessage="IQ Games" />
                </a>
              </div>
              <div className="account__links__btn-wrap">
                <a
                  className="account__links__btn"
                  href={`/#/home?uid=${this.props.access.uid}`}
                  onClick={(e) =>
                    (window.location = `https://explore.mobioastro.com/?uid=${this.props.access.uid}`)
                  }
                >
                  <FormattedMessage id="astrology" defaultMessage="Astrology" />
                </a>
              </div>
            </div>
          ) : (
            ""
          )}
          {config.subDomain == "uk" ||
          config.subDomain === "es.trendme" ||
          config.subDomain === "pt.videoflux" ||
          config.subDomain === "ee" ||
          config.subDomain === "tr" ||
          config.subDomain === "vn" ||
          config.subDomain === "sn" ||
          config.subDomain == "be" ||
          config.subDomain === "it" ||
          config.subDomain === "nl" ||
          config.subDomain === "gh" ||
          config.subDomain === "se" ||
          config.subDomain === "no" ||
          config.subDomain === "ch" ||
          config.subDomain === "my" ||
          config.subDomain === "cz" ? (
            <div className="account__links">
              {(config.subDomain !== "be" &&
                config.subDomain !== "es.trendme") ||
              (config.subDomain !== "pt.videoflux" &&
                config.subDomain !== "nl" &&
                config.subDomain !== "tr" &&
                config.subDomain !== "ee" &&
                config.subDomain !== "it" &&
                config.subDomain !== "gh" &&
                config.subDomain !== "no" &&
                config.subDomain !== "sn" &&
                config.subDomain !== "ch" &&
                config.subDomain !== "my" &&
                config.subDomain !== "cz") ? (
                <div className="account__links__btn-wrap">
                  <a
                    className="account__links__btn"
                    href={ppLink[config.subDomain]}
                    target="_blank"
                  >
                    <FormattedMessage
                      id="privacyPolicy"
                      defaultMessage="Privacy Policy"
                    />
                  </a>
                </div>
              ) : (
                ""
              )}

              {config.subDomain !== "it" &&
              config.subDomain !== "sn" &&
              config.subDomain !== "tr" &&
              config.subDomain !== "ch" &&
              config.subDomain !== "my" &&
              config.subDomain !== "cz" ? (
                <div className="account__links__btn-wrap">
                  <a
                    className="account__links__btn"
                    href={tncLink[config.subDomain]}
                    target="_blank"
                  >
                    <FormattedMessage
                      id="tnc"
                      defaultMessage="Terms and Conditions"
                    />
                  </a>
                </div>
              ) : null}
              {config.subDomain != "nl" ? (
                <div className="account__links__btn-wrap">
                  <div
                    className="account__links__btn"
                    onClick={this.onUnsub}
                    style={{ cursor: "pointer" }}
                    id={unsubLink[config.subDomain]}
                  >
                    <span style={{ pointerEvents: "none" }}>
                      <FormattedMessage
                        id="unsub"
                        defaultMessage="Unsubscribe"
                      />
                    </span>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
        </Container>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      showMessage,
      getDetails,
      setDetails,
      setProfilePic,
      setHeaderTitle,
      getInterests,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/components/Account/Account.js